import { faRocket, faSignIn } from '@fortawesome/pro-light-svg-icons'
import React, { FC } from 'react'

import { Button } from '../../layout_components/Button'
import { locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import LanguageSwitcher from '../LanguageSwitcher'
import { AccessButtons } from './header.components'

const TopButtons: FC = () => {
  const realm = useAppSelector((state) => state.realm.value)

  // DIC SPAGNA will habe DIC_LOGIN and DIC_REGISTRATION Env variable setted diffrently
  const urlRegister = realm === 'fic' ? process.env.FIC_REGISTRATION ?? 'https://www.fattureincloud.it/service/form/form-registrazione/'
    : process.env.DIC_REGISTRATION ?? 'https://secure.dipendentincloud.it/registration/register'
  const urlLogin = realm === 'fic'
    ? process.env.FIC_LOGIN ?? 'https://secure.fattureincloud.it/login'
    : realm === 'dic'
      ? process.env.DIC_LOGIN ?? 'https://secure.dipendentincloud.it/login?status=login'
      : 'https://reseller.fattureincloud.it/login'


  return (
    <AccessButtons>
      {realm != 'resellers' && (
        <Button
          text={locale('Prova Gratis')}
          type={'text'}
          iconLeft={faRocket}
          onClick={() => window.open(urlRegister, '_target')}
          href={urlRegister}
          reloadPage={false}
        />
      )}
      <Button
        text={locale('Accedi')}
        type={'text'}
        iconLeft={faSignIn}
        onClick={() => window.open(urlLogin, '_target')}
        href={urlLogin}
        reloadPage={false}
      />
      {process.env.REACT_APP_ENV != 'production' && <LanguageSwitcher />}
    </AccessButtons>
  )
}

export default TopButtons
